/* Draggable before/after comparison for sections/advertorial-hero.liquid.
   The divider position lives in --ah-pos on [data-ah-compare]; the visually
   hidden range input inside it is the keyboard and screen reader control and
   stays in sync with drags. */
(function () {
  if (window.JiYuAdvertorialHero) return;

  var bound = new WeakSet();
  var MIN = 3;
  var MAX = 97;

  function bind(box) {
    if (bound.has(box)) return;
    bound.add(box);

    var input = box.querySelector('[data-ah-input]');
    var dragging = false;
    var pointerId = null;

    function set(pct) {
      pct = Math.max(MIN, Math.min(MAX, pct));
      box.style.setProperty('--ah-pos', pct + '%');
      if (input) input.value = Math.round(pct);
    }

    function fromClientX(x) {
      var rect = box.getBoundingClientRect();
      if (!rect.width) return;
      set(((x - rect.left) / rect.width) * 100);
    }

    box.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      try {
        box.setPointerCapture(e.pointerId);
      } catch (_) {}
      fromClientX(e.clientX);
    });

    box.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      fromClientX(e.clientX);
    });

    function end(e) {
      if (e.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
    }
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', end);
    box.addEventListener('lostpointercapture', end);

    if (input) {
      input.addEventListener('input', function () {
        set(parseFloat(input.value) || 50);
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ah-compare]').forEach(bind);
  }

  window.JiYuAdvertorialHero = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
